// import { AiStar } from '@/assets/icons/interview';
import { AiButton } from '@/componentsV1/AI/AiButton';
import { KText } from '@/ui-library/components';
// import { KPopover } from '@/ui-library/components/organisms/KPopover';
import {
  // Box,
  Flex,
  // Icon,
  // IconButton,
  // Textarea,
  Tooltip,
  useDisclosure,
} from '@chakra-ui/react';
// import { ArrowUp } from '@kula-ai/icons/solid/ArrowUp';
// import { IconButton as KIconButton } from '@/components/ats';

export const FillWithAIHeader = ({
  isEmptyTranscript = false,
  isLoading = false,
  // setDescription = () => {},
  handleFillWithAi = () => {},
}: // description = '',
{
  isEmptyTranscript: boolean;
  isLoading: boolean;
  setDescription: (description: string) => void;
  handleFillWithAi: (params: { description: string }) => void;
  description: string;
}) => {
  const popoverActions = useDisclosure();

  const isDisabled = isEmptyTranscript || isLoading;

  // Prevent popover from opening when loading
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const controlledPopoverActions = {
    isOpen: isDisabled ? false : popoverActions.isOpen,
    onOpen: isDisabled ? () => {} : popoverActions.onOpen,
    onClose: popoverActions.onClose,
    onToggle: isDisabled ? () => {} : popoverActions.onToggle,
  };

  return (
    <Flex
      w="100%"
      bg="#F9F5FF"
      justifyContent="space-between"
      gap="16px"
      p="16px 24px"
      alignItems="center"
    >
      <Flex gap="3px" flexDir="column">
        <KText variant="heading_4" color="primary-900">
          Use AI to fill out your scorecard
        </KText>
        <KText variant="paragraph">
          You can modify what the AI filled out before submitting the scorecard
        </KText>
      </Flex>
      <Tooltip
        variant="ats-primary"
        label={
          isEmptyTranscript
            ? 'Unable to fill with AI as there is no transcript'
            : ''
        }
      >
        <AiButton
          text={isLoading ? 'Generating' : 'Fill scorecard with AI'}
          isDisabled={isEmptyTranscript || isLoading}
          secondIcon={false}
          styles={{
            boxShadow:
              '0px 4px 10px 0px #B15FDA1A, 0px 18px 18px 0px #B15FDA17, 0px 40px 24px 0px #B15FDA0D, 0px 71px 29px 0px #B15FDA03, 0px 111px 31px 0px #B15FDA00',
            height: '34px',
          }}
          textStyles={{ whiteSpace: 'nowrap' }}
          onClick={() => {
            handleFillWithAi({ description: '' });
          }}
        />
      </Tooltip>
      {/* TODO: comment out for now */}
      {/* <Tooltip
        variant="ats-primary"
        label={
          isEmptyTranscript
            ? 'Unable to fill with AI as there is no transcript'
            : ''
        }
      >
        <Box
          sx={{
            '.chakra-popover__popper': {
              zIndex: 12,
            },
          }}
        >
          <KPopover
            triggerElement={
              <Box pointerEvents={isDisabled ? 'none' : 'auto'}>
                <AiButton
                  text={isLoading ? 'Generating' : 'Fill scorecard with AI'}
                  isDisabled={isEmptyTranscript || isLoading}
                  secondIcon={false}
                  styles={{
                    boxShadow:
                      '0px 4px 10px 0px #B15FDA1A, 0px 18px 18px 0px #B15FDA17, 0px 40px 24px 0px #B15FDA0D, 0px 71px 29px 0px #B15FDA03, 0px 111px 31px 0px #B15FDA00',
                    height: '34px',
                  }}
                  textStyles={{ whiteSpace: 'nowrap' }}
                />
              </Box>
            }
            popoverContentProps={{
              p: '20px',
              minW: '480px',
              borderRadius: '6px',
              boxShadow: '0px 4px 24px 0px #1A1A381A',
              border: '1px solid transparent',
              bg: 'linear-gradient( #fff, #fff) padding-box,linear-gradient(180deg, #8A90FF 0%, #B15FDA 100%)',
              borderColor: 'transparent',
            }}
            popoverBodyProps={{ p: 0 }}
            popoverProps={{ placement: 'bottom-end' }}
            showArrow={false}
            popoverActions={controlledPopoverActions}
          >
            <Flex flexDir="column" w="100%" gap="8px">
              <Flex alignItems="center" gap="8px">
                <Icon as={AiStar} w="16px" h="16px" />
                <KText
                  variant="heading_4"
                  bgGradient="linear(to-b, #8A90FF, #B15FDA)"
                  bgClip="text"
                >
                  Fill scorecard with AI
                </KText>
              </Flex>
              <KText variant="paragraph" mb="12px">
                Describe the interview and the AI will fill the scorecard for
                you
              </KText>
              <Textarea
                placeholder={`Example: "While the candidate communicated their approach in detail, they demonstrated gaps in product thinking."`}
                variant="ats-textarea-variant-1"
                _placeholder={{
                  color: 'secondary-500',
                }}
                borderColor="border-color"
                _focus={{}}
                _active={{}}
                autoFocus={true}
                onChange={(e) => setDescription(e.target.value)}
                value={description}
              />
              <Flex ml="auto" gap="16px">
                <KIconButton
                  icon={null}
                  text="Skip and fill"
                  onClick={() => {
                    setDescription('');
                    controlledPopoverActions.onClose();
                    handleFillWithAi({ description: '' });
                  }}
                  iconContainerProps={{
                    width: 'unset',
                    height: 'unset',
                    bg: 'unset',
                  }}
                  iconProps={{ width: '14px', height: '14px' }}
                  gap="6px"
                />
                <IconButton
                  icon={
                    <Icon as={ArrowUp} color="base-white" w="16px" h="16px" />
                  }
                  aria-label="Fill scorecard with AI"
                  minW="22px"
                  w="22px"
                  maxH="22px"
                  borderRadius="full"
                  bg="linear-gradient(180deg, #8A90FF 0%, #B15FDA 100%)"
                  color="base-white"
                  _hover={{}}
                  _active={{}}
                  px="0"
                  onClick={() => {
                    if (description?.length === 0) return;
                    handleFillWithAi({ description });
                    controlledPopoverActions.onClose();
                  }}
                />
              </Flex>
            </Flex>
          </KPopover>
        </Box>
      </Tooltip> */}
    </Flex>
  );
};
